import ConfirmDeleteDialog from '../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog';
import useDeleteDocumentModal, { type DocumentToDelete } from './useDeleteDocumentModal';

export type { DocumentToDelete };

// Keeps the French quotes and question mark on the document name's line.
const NBSP = '\u00a0';

type Props = {
  document: DocumentToDelete;
  onClose: () => void;
};

export default function DeleteDocumentModal(props: Props) {
  const { handleConfirm } = useDeleteDocumentModal(props);

  return (
    <ConfirmDeleteDialog
      title="Supprimer le document"
      onConfirm={handleConfirm}
      onClose={props.onClose}
    >
      Êtes-vous sûr de vouloir supprimer le document «{NBSP}{props.document.name}{NBSP}»{NBSP}?
    </ConfirmDeleteDialog>
  );
}
